import { make } from 'foundations-components/transitional/utils/SimpleDate';
export const EDITOR_TYPES = {
  CUSTOMIZE: 'CUSTOMIZE',
  CREATE_CATEGORIES: 'CREATE_CATEGORIES',
  CREATE_ARTICLE: 'CREATE_ARTICLE'
};
export const EMPTY_STRING = '';
export const EMPTY_ARRAY = [];
export const MIN_CUSTOM_DATE = make(2018, 0, 1);